import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _classCallCheck from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits"; //@ts-check

import React from 'react';
import connect from '../../core/EcrionProvider/connect';
import GridView from '../../data/Grid/GridView';
import GridViewThumbnailItem from '../../data/Grid/GridView/Thumbnail/Item';
import GridViewDetailItem from '../../data/Grid/GridView/Detail/Item';
import addItemContextMenu from './contextMenu/addItemContextMenu';
import currentSelector from '../selectors/grid';
import _loadData from '../actions/grid/load';
import _refresh from '../actions/grid/refresh';
import { gotoPage, changeItemsPerPage as _changeItemsPerPage } from '../actions/grid/page';
import _changeSort from '../actions/grid/sort';
import _changeFilter from '../actions/grid/filter';
import _changeMode from '../actions/grid/mode';
import { selectItem as _selectItem, spatialSelectItem as _spatialSelectItem } from '../actions/grid/select';
import autoRefresh from '../autoRefresh';
import Utils from '../../utils';
import instances from './instances';
import { HotKeys } from 'react-hotkeys';
var KEY_MAP = {
  SELECTION_UP: 'up',
  SELECTION_DOWN: 'down',
  SELECTION_LEFT: 'left',
  SELECTION_RIGHT: 'right',
  SELECTION_FIRST: 'home',
  SELECTION_LAST: 'end',
  SELECTION_FIRST_ON_PAGE: 'pageup',
  SELECTION_LAST_ON_PAGE: 'pagedown'
};
/**
 *
 * @typedef {object} Props
 */

/**
 *
 * @typedef {object} InjectedProps
 * @property {import('data/types').DataGridViewState} [grid] Injected by HoC
 * @property {(any) => any} [spatialSelectItem] Injected by HoC
 */

/**
 * @extends {React.Component<Props & InjectedProps>}
 */

var DataGrid =
/*#__PURE__*/
function (_React$Component) {
  _inherits(DataGrid, _React$Component);

  function DataGrid(props) {
    var _this;

    _classCallCheck(this, DataGrid);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DataGrid).call(this, props));

    _this.loadData = function (e) {
      var silent = !!(e && e.silent);
      return _this.props.loadData(e, _objectSpread({}, _this.props, {
        silent: silent
      }));
    };

    _this.changePage = function (e, newPageIdx) {
      return _this.props.changePage(e, _objectSpread({}, _this.props, {
        page: newPageIdx
      }));
    };

    _this.changeItemsPerPage = function (e, newItemsPerPage) {
      return _this.props.changeItemsPerPage(e, _objectSpread({}, _this.props, {
        itemsPerPage: newItemsPerPage
      }));
    };

    _this.refresh = function (options) {
      return _this.props.refresh(_objectSpread({}, _this.props, options));
    };

    _this.changeSort = function (e, by) {
      return _this.props.changeSort(e, _objectSpread({}, _this.props, {
        by: by
      }));
    };

    _this.changeFilter = function (e, filter, by) {
      return _this.props.changeFilter(e, _objectSpread({}, _this.props, {
        filter: filter,
        by: by
      }));
    };

    _this.changeMode = function (e, mode) {
      return _this.props.changeMode(e, _objectSpread({}, _this.props, {
        mode: mode
      }));
    };

    _this.selectItem = function (e, item) {
      return _this.props.selectItem('click', e, _this.props, item);
    };

    _this.doubleClick = function (e, item) {
      _this.props.selectItem('doubleClick', e, _this.props, item);

      if (_this.props.onDoubleClick) _this.props.onDoubleClick(e, item);
    };

    _this.clearSelection = function (e) {
      return _this.props.selectItem('clear', e, _this.props);
    };

    var spatialCommand = function spatialCommand(e, type) {
      _this.props.spatialSelectItem(_objectSpread({}, e, {
        type: type
      }), _this.props);

      e.stopPropagation();
      e.preventDefault();
    };

    _this.handlers = {
      SELECTION_UP: function SELECTION_UP(e) {
        return spatialCommand(e, 'up');
      },
      SELECTION_DOWN: function SELECTION_DOWN(e) {
        return spatialCommand(e, 'down');
      },
      SELECTION_LEFT: function SELECTION_LEFT(e) {
        return spatialCommand(e, 'left');
      },
      SELECTION_RIGHT: function SELECTION_RIGHT(e) {
        return spatialCommand(e, 'right');
      },
      SELECTION_FIRST: function SELECTION_FIRST(e) {
        return spatialCommand(e, 'first');
      },
      SELECTION_LAST: function SELECTION_LAST(e) {
        return spatialCommand(e, 'last');
      },
      SELECTION_FIRST_ON_PAGE: function SELECTION_FIRST_ON_PAGE(e) {
        return spatialCommand(e, 'first-on-page');
      },
      SELECTION_LAST_ON_PAGE: function SELECTION_LAST_ON_PAGE(e) {
        return spatialCommand(e, 'last-on-page');
      }
    };
    return _this;
  }

  _createClass(DataGrid, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      instances.register(this.props.id, this);
      this.autoRefresh = autoRefresh(this.props, this.loadData);
      /**@deprecated Use DataAction.grid instead */

      if (this.props.actions) {
        this.props.actions({
          refresh: this.refresh
        });
      }

      if (typeof this.props.defaultSelection !== 'undefined') {
        this.props.selectItem('defaultSelection', {
          type: 'defaultSelection'
        }, this.props, this.props.defaultSelection);
      }

      this.loadData().then(function (action) {
        if (_this2.props.autoSelectFirstValue) {
          var hasInitialSelection = true;
          if (typeof _this2.props.defaultSelection === 'undefined') hasInitialSelection = false;else if (!_this2.props.defaultSelection.length) hasInitialSelection = false;

          if (!hasInitialSelection && action.payload.Data && action.payload.Data.length > 0) {
            var firstItem = action.payload.Data[0];

            if (firstItem) {
              _this2.props.selectItem('click', {
                type: 'autoSelectFirstValue'
              }, _this2.props, firstItem);
            }
          }
        }
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this3 = this;

      if (!Utils.deepEqual(this.props.dataProps, prevProps.dataProps)) {
        var e = {
          type: 'dataPropsUpdated'
        };
        this.loadData(e).then(function () {
          _this3.clearSelection(e);
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      instances.unregister(this.props.id);
      if (this.autoRefresh) this.autoRefresh.stop();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          grid = _this$props.grid,
          styles = _this$props.styles,
          viewProps = _this$props.viewProps;
      var uid = this.props.dataType + (this.props.id ? '-' + this.props.id : '');
      return React.createElement(HotKeys, {
        keyMap: KEY_MAP,
        handlers: this.handlers,
        style: {
          outline: 'none'
        }
      }, React.createElement(GridView, Object.assign({
        config: grid,
        onChangePage: this.changePage,
        onChangeItemsPerPage: this.changeItemsPerPage,
        onChangeSort: this.changeSort,
        onChangeFilter: this.changeFilter,
        onChangeMode: this.changeMode,
        onClick: this.selectItem,
        onDoubleClick: this.doubleClick,
        styles: styles,
        rowComponent: addItemContextMenu(GridViewDetailItem, grid, uid + '-row'),
        thumbnailComponent: addItemContextMenu(viewProps.thumbnailComponent || GridViewThumbnailItem, grid, uid + 'thumb')
      }, viewProps)));
    }
  }]);

  return DataGrid;
}(React.Component);

var mapStateToProps = function mapStateToProps(state, ownProps) {
  // @ts-ignore
  var grid = currentSelector(state, ownProps);
  return {
    grid: grid
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    loadData: function loadData(e, props) {
      return dispatch(_loadData(props));
    },
    changePage: function changePage(e, props) {
      return dispatch(gotoPage(props));
    },
    changeItemsPerPage: function changeItemsPerPage(e, props) {
      return dispatch(_changeItemsPerPage(props));
    },
    changeSort: function changeSort(e, props) {
      return dispatch(_changeSort(props));
    },
    changeFilter: function changeFilter(e, props) {
      return dispatch(_changeFilter(e, props));
    },
    changeMode: function changeMode(e, props) {
      return dispatch(_changeMode(props));
    },
    refresh: function refresh(props) {
      return dispatch(_refresh(props));
    },
    selectItem: function selectItem(selectionType, e, props, item) {
      if (props.selectable) {
        return dispatch(_selectItem(selectionType, e, props, item, props.onSelect));
      }
    },
    spatialSelectItem: function spatialSelectItem(e, props) {
      if (props.selectable) return dispatch(_spatialSelectItem(e, props, props.onSelect));
    }
  };
};

DataGrid.defaultProps = {
  selectable: false,
  autoSelectFirstValue: false,
  blockEmptyUnselect: false,
  viewProps: {}
};
export default connect(mapStateToProps, mapDispatchToProps)(DataGrid);